import React from 'react'
import { fileUrl } from 'src/utils/lib'
import _ from 'lodash'

import { StyledBox } from './Styled'

const ActionImage = ({ row }) => {
  const defaultImage = '/icon/img_empty.png'
  const image = _.get(row, 'image', '')
  const imgSrc = image
    ? image.startsWith('/')
      ? fileUrl(image)
      : `${window.__env__.REACT_APP_FILE_URL}/${image}`
    : defaultImage
  return <StyledBox img={imgSrc}></StyledBox>
}

export default ActionImage
